import styled from '@emotion/styled';
import colors from '../../../styling/colors';

export default styled.input`
  border: 1px solid ${({ error }) => (error ? colors('error') : colors('alto'))};
  color: ${colors('mineshaft')};
  display: block;
  height: 2.75rem;
  padding: 0 1rem;
  margin: 0 0 1rem;
  width: 100%;

  &::placeholder {
    color: ${colors('alto')};
  }
`;
